import styled from 'styled-components'

export const Container = styled.section`
  align-items: center;
  background-color: var(--primary);
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 32px;
  padding: 32px 0 62px 32px;

  h2 {
    color: var(--secondary);
    line-height: 32px;
    padding-right: 32px;
    text-align: center;
  }

  @media (max-width: 950px) {
    padding: 0 0 24px 32px;
  }
`

export const Content = styled.div`
  display: flex;
  gap: 16px;
  overflow-x: auto;
  scroll-behavior: smooth;
  max-width: 100%;
  padding-right: 32px;
`
